/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getReferalEmployeeListAsync } from '../dataActions/DataActionExtension.g';

/**
 * GetEmployeeReferralsList Input Action
 */
export class GetEmployeeReferralsListInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor() {}

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `TODO`;
  public getCacheObjectType = () => 'TODO';
  public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IEmployeeReferral {
  StaffId: string;
  Name?: string;
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetEmployeeReferralsListData {
  referralsList: IEmployeeReferral[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new GetEmployeeReferralsListInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function GetEmployeeReferralsListAsync(
  input: GetEmployeeReferralsListInput,
  ctx: Msdyn365.IActionContext
): Promise<IGetEmployeeReferralsListData> {
  try {
    const response = await getReferalEmployeeListAsync({ callerContext: ctx });
    const mappedResponse: IEmployeeReferral[] = response.map(item => ({
        StaffId: item.StaffId,
        Name: item.Name
    }));
    return { referralsList: mappedResponse };
  } catch (error) {
    return { referralsList: [] };
  }
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<IGetEmployeeReferralsListData>>(
    GetEmployeeReferralsListAsync
  ),
  // TODO: Give your data action a unique id
  id: 'GetEmployeeReferralsList',
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
